/**
 * The entrypoint for the V2 account shortcode.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import "./style/shortcode/accountV2/style.scss";
import moment from "moment";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { Provider } from "./components/provider.js";
import { AccountV2Router } from "./shortcode/accountV2/router.js";
ready().then(()=>{
    const elements = document.querySelectorAll("div.real-commerce-account-v2");
    elements.forEach((item)=>{
        // The PHP shortcode renders `data-checkout="<permalink>"` when an
        // editor has configured `checkout="<page-id>"`. We expose it on the
        // existing `window.realCommerceCheckout.checkoutUrl` global so the
        // expired-subscription card can deep-link into the checkout with the
        // customer's previous product+plan pre-selected. Empty string → leave
        // the global untouched (fallback path stays effective).
        const checkoutUrl = item.dataset.checkout;
        if (checkoutUrl) {
            window.realCommerceCheckout = {
                ...window.realCommerceCheckout,
                checkoutUrl
            };
        }
        createRoot(item).render(/*#__PURE__*/ _jsx(Provider, {
            configProvider: {
                locale: {
                    locale: moment.locale()
                }
            },
            children: /*#__PURE__*/ _jsx(AccountV2Router, {})
        }));
    });
});
